import { render, staticRenderFns } from "./create-scheme.vue?vue&type=template&id=b181ee30&scoped=true"
import script from "./create-scheme.vue?vue&type=script&lang=js"
export * from "./create-scheme.vue?vue&type=script&lang=js"
import style0 from "./create-scheme.vue?vue&type=style&index=0&id=b181ee30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b181ee30",
  null
  
)

export default component.exports